__webpack_require__.p = "/skeleton/assets/";